export default __webpack_public_path__ + "static/media/Leaders_IMG-Pathooraman.4110f1ac.png";